// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* games/tetris/Tetris.css */

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* --- ГЛАВНЫЙ КОНТЕЙНЕР --- */
.tetris-board-container {
  position: fixed;

  /* 1. ЦЕНТРИРОВАНИЕ */
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); /* Сдвигаем точку привязки в центр элемента */

  /* 2. РАЗМЕРЫ И ОТСТУПЫ ОТ КРАЕВ ЭКРАНА */
  width: 96vw;       /* 2% отступа слева и справа */
  max-width: 400px;  /* Максимальная ширина */

  height: calc(100% - 20px); /* 10px отступа сверху и 10px снизу */
  max-height: 900px; /* На очень высоких экранах не растягивать до бесконечности */

  /* 3. МАТЕРИАЛЬНОСТЬ (КОРПУС) */
  background-color: #222;
  background-image:
    linear-gradient(rgba(255,255,255,0.02) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255,255,255,0.02) 1px, transparent 1px);
  background-size: 20px 20px;

  border: 4px solid #2c3e50; /* Рамка корпуса */
  border-radius: 16px;       /* Скругление углов */

  /* Тени: контур, блик, глубокая тень */
  box-shadow:
      0 0 0 1px #000,
      inset 0 1px 0 rgba(255,255,255,0.1),
      0 20px 60px rgba(0,0,0,0.9);

  /* 4. ВНУТРЕННИЕ ОТСТУПЫ (СТЕНКИ ВОКРУГ ЭКРАНА) */
  /* Сверху 15, Снизу 15, По бокам 20 - создает ощущение рамок экрана */
  padding: 15px 12px 15px 12px;

  /* FLEX LAYOUT */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  color: #bdc3c7;
  font-family: 'Courier New', monospace;
  z-index: 6000;
  -webkit-user-select: none;
          user-select: none;
  box-sizing: border-box;

    /* Блокируем стандартные жесты браузера (скролл, зум) */
    touch-action: none;
    overflow: hidden;
}

/* ЗАГОЛОВОК */
.tetris-header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px; /* Небольшой отступ от экрана игры */
  padding: 6px 10px;
  background: #151515;
  border-bottom: 1px solid #333;
  border-radius: 4px;
  flex-shrink: 0;
  box-sizing: border-box;
}

.tetris-title {
  font-weight: 900;
  text-transform: uppercase;
  color: #e67e22;
  letter-spacing: 1px;
  font-size: 14px;
  text-shadow: 0 1px 2px black;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 10px;
}

.tetris-timer {
  font-family: monospace;
  font-weight: bold;
  color: #888;
  font-size: 14px;
}

/* ИГРОВАЯ ЗОНА */
.tetris-main-area {
  display: flex;
  gap: 12px; /* Расстояние между Колодцем и Панелью */
  justify-content: center;

  /* ИЗМЕНЕНО: Было center. Ставим flex-start,
     чтобы и колодец, и сайдбар прижимались к верхней грани зоны. */
  align-items: flex-start;

  width: 100%;
  flex: 1 1;      /* Занимаем всё доступное место по высоте */
  min-height: 0; /* Разрешаем сжиматься */

  position: relative;
  margin-bottom: 10px; /* Отступ до кнопок управления */
}

/* СЕТКА (КОЛОДЕЦ) */
.tetris-grid {
  background: #0e0e0e;
  border: 1px solid #444;
  border-top: none;

  display: grid;

  /* Пытаемся занять всю высоту, пока не упремся в maxHeight из JS */
  height: 100%;

  /* ЖЕСТКИЙ ЗАПРЕТ на сплющивание Flex-контейнером */
  flex-shrink: 0;

  box-shadow: inset 0 0 30px rgba(0,0,0,0.9);
  position: relative;
}

/* Media query больше не нужна - calc() уже учитывает ограничения по высоте */

/* Фоновая сетка внутри колодца */
.tetris-grid::before {
  content: '';
  position: absolute; inset: 0;
  background-image:
    linear-gradient(rgba(255,255,255,0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255,255,255,0.05) 1px, transparent 1px);

  /* Используем CSS-переменные, передаваемые из React */
  background-size: var(--bg-size-x, 12.5%) var(--bg-size-y, 6.666%);
  pointer-events: none;
}

.tetris-cell {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  /* Границы ячеек убраны для чистоты, оставим только у блоков */
}

/* --- МАТЕРИАЛЫ БЛОКОВ --- */

/* Базовый слой 3D объема для всех фигур */
.cell-filled {
  border: 1px solid rgba(0,0,0,0.3);
  box-shadow:
    inset 2px 2px 2px rgba(255,255,255,0.3),
    inset -2px -2px 3px rgba(0,0,0,0.5),
    0 4px 8px rgba(0,0,0,0.4);
  border-radius: 2px;
  position: relative;
  overflow: hidden;
  container-type: inline-size; /* <-- ДОБАВЛЕНО ДЛЯ ДИНАМИЧЕСКИХ ШРИФТОВ */
}

/* 1. I (Палка) - ТЕПЕРЬ ЗЕРКАЛЬНОЕ ЗОЛОТО (Самая ценная фигура) */
.type-I {
  background: linear-gradient(135deg,
    #ffeaa7 0%,
    #f1c40f 25%,
    #ffffff 45%,
    #f3ce12 55%,
    #d4af37 80%,
    #a67a0b 100%);
  border: 1px solid #996515;
}
.type-I::after {
  content: '999';
  position: absolute; inset: 0; display: flex; align-items: center; justify-content: center;
  font-size: 11px; /* Увеличенный фолбэк */
  font-size: 45cqw; /* <-- Было 35, стало 45 (крупнее, но 3 цифры влезут) */
  font-weight: 900; color: #8c5c13; opacity: 0.6;
}

/* 2. J (Крюк) - ТЕПЕРЬ ДЕРЕВЯННЫЕ ЯЩИКИ (Вместо Т-фигуры) */
.type-J {
  background-color: #7b502a;
  background-image: repeating-linear-gradient(90deg,
    rgba(0,0,0,0.1) 0px,
    rgba(0,0,0,0.1) 1px,
    transparent 1px,
    transparent 8px);
}
.type-J::after {
  content: '⚠';
  position: absolute; inset: 0; display: flex; align-items: center; justify-content: center;
  font-size: 18px; /* Увеличенный фолбэк */
  font-size: 80cqw; /* <-- Было 60, стало 80 (один символ отлично впишется) */
  color: rgba(0,0,0,0.2); font-weight: bold;
}

/* 3. L (Г-фигура) - ОРУЖЕЙНЫЙ КЕЙС (Без изменений) */
.type-L {
  background: linear-gradient(135deg, #455a64 0%, #263238 100%);
  border-color: #1c272b;
}
.type-L::after {
  content: ''; position: absolute;
  top: 25%; left: 15%; width: 70%; height: 20%;
  background: rgba(255,255,255,0.7);
  border-radius: 1px;
}

/* 4. O (Квадрат) - ТЕПЕРЬ КАРТОННЫЕ КОРОБКИ (Вместо Палки) */
.type-O {
  background-color: #c6a664;
  background-image: linear-gradient(to bottom, #d2b48c, #b89a5b);
}
.type-O::after {
  content: ''; position: absolute;
  top: 0; left: 30%; width: 40%; height: 100%;
  background: rgba(139, 69, 19, 0.2);
  border-left: 1px solid rgba(0,0,0,0.1);
  border-right: 1px solid rgba(0,0,0,0.1);
}

/* 5. S (Зигзаг) - ПОЛИЦЕЙСКАЯ ЛЕНТА (Без изменений) */
.type-S {
  background: #fbc02d;
  background-image: repeating-linear-gradient(-45deg, #222 0, #222 6px, transparent 6px, transparent 12px);
}

/* 6. T (Т-образная) - ТЕПЕРЬ ЗЕРКАЛЬНОЕ СЕРЕБРО (Вторая по важности) */
.type-T {
  background: linear-gradient(135deg,
    #95a5a6 0%,
    #ffffff 40%,
    #eeeeee 50%,
    #bdc3c7 60%,
    #7f8c8d 100%);
}
.type-T::after {
  content: 'AG';
  position: absolute; inset: 0; display: flex; align-items: center; justify-content: center;
  font-size: 13px; /* Увеличенный фолбэк */
  font-size: 55cqw; /* <-- Было 40, стало 55 (две буквы будут выглядеть сочно) */
  font-weight: 900; color: rgba(0,0,0,0.25); letter-spacing: 1px;
}

/* 7. Z (Зигзаг) - ПАКЕТЫ ВЕЩДОКОВ (Без изменений) */
.type-Z {
  background: linear-gradient(135deg, #ffffff 0%, #f0f0f0 100%);
  border-color: #bdc3c7;
}
.type-Z::before {
  content: ''; position: absolute; inset: 0;
  background:
    linear-gradient(115deg, transparent 40%, rgba(255,255,255,0.9) 47%, rgba(255,255,255,0.9) 52%, transparent 60%),
    linear-gradient(25deg, transparent 20%, rgba(255,255,255,0.4) 25%, transparent 30%);
  z-index: 1;
}

/* --- БОКОВАЯ ПАНЕЛЬ --- */
.tetris-sidebar {
  display: flex;
  flex-direction: column;
  gap: 18px; /* Чуть увеличили отступ, чтобы блоки не слипались при большем шрифте */

  height: 100%;
  width: 65px; /* Расширили на 5px для комфортного размещения крупного шрифта */
  flex-shrink: 0;

  justify-content: flex-start;
  align-items: center;
}

/* Новые минималистичные группы статистики */
.stat-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 4px; /* Чуть больше воздуха между подписью и цифрой */
  width: 100%;
}

.sb-label {
  font-size: 13px; /* Увеличили шрифт (было 11px) */
  font-weight: 800;
  color: #7f8c8d; /* Теплый, спокойный серый цвет, в тон интерфейсу */
  text-transform: uppercase;
  letter-spacing: 0.5px;
  text-shadow: 0 1px 2px rgba(0,0,0,0.8);
  white-space: nowrap;
}

.sb-val {
  font-size: 19px; /* Увеличили цифры (было 16px) */
  font-weight: 900;
  color: #ecf0f1; /* Мягкий белый (не режет глаз) */
  text-shadow: 0 2px 4px rgba(0,0,0,0.9);
  line-height: 1;
}

/* --- КНОПКИ САЙДБАРА --- */
.sidebar-btn {
  /* Спокойный темно-серый цвет, без градиентов */
  background-color: #4a4a52;
  border: 1px solid #333;
  border-radius: 6px;
  color: #e0e0e0;

  height: 32px;
  padding: 0;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;

  /* Легкая аккуратная тень для отделения от фона */
  box-shadow: 0 2px 0 #2a2a30;
  transition: all 0.15s ease;
}

/* Нажатие на включенную кнопку */
.sidebar-btn:active {
  transform: translateY(2px);
  box-shadow: none; /* Тень пропадает при нажатии */
  background-color: #3d3d44;
}

/* Состояние: ПАУЗА (Сплошной зеленый) */
.sidebar-btn.paused {
  background-color: #27ae60;
  border-color: #1e8449;
  box-shadow: 0 2px 0 #145a32;
  color: #fff;
}
.sidebar-btn.paused:active {
  transform: translateY(2px);
  box-shadow: none;
  background-color: #219653;
}

/* Состояние: КНОПКИ СКРЫТЫ (Выключено) */
/* Кнопка становится плоской и гаснет, сливаясь с фоном сайдбара */
.sidebar-btn.controls-off {
  background-color: #242428; /* Очень темный серый, почти фон */
  border: 1px solid #1a1a1d;
  box-shadow: none; /* Нет тени — кнопка плоская, а не вдавленная */
  color: #4a4a52; /* Тусклая иконка в цвет выключенного состояния */
  transform: none; /* Никакого сдвига вниз */
}

/* Легкая реакция на клик по выключенной кнопке (при включении) */
.sidebar-btn.controls-off:active {
  background-color: #2a2a30;
}

/* Увеличенная иконка контроллера */
.icon-gamepad {
  font-size: 24px;
}

/* ОВЕРЛЕЙ ПАУЗЫ */
.tetris-paused-overlay {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(2px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 40;
  pointer-events: none; /* Чтобы клики не перехватывал, хотя кнопки и так заблокированы логикой */
}

.paused-text {
  font-size: 24px;
  font-weight: 900;
  color: #fff;
  letter-spacing: 4px;
  text-transform: uppercase;
  border: 2px solid #fff;
  padding: 5px 15px;
  transform: rotate(-5deg);
  background: rgba(0,0,0,0.5);
}

/* БЛОК СЛЕДУЮЩЕЙ ФИГУРЫ */
.next-piece-container {
  width: 54px;
  height: 54px;
  margin-top: 2px;

  background: rgba(0, 0, 0, 0.3); /* Легкое затемнение фона (эффект экранчика) */
  border: 2px solid #4a4a52; /* Серая рамка в цвет кнопок интерфейса */
  border-radius: 4px;

  /* Внутренняя тень создает ощущение физического углубления в корпусе */
  box-shadow: inset 0 2px 5px rgba(0,0,0,0.8), 0 1px 0 rgba(255,255,255,0.05);

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3px;
}

.next-piece-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(4, 1fr);
  width: 100%;
  height: 100%;
  gap: 1px;
}
.mini-cell { width: 100%; height: 100%; }

/* --- УПРАВЛЕНИЕ --- */
.tetris-controls {
  width: 100%;
  /* Запрещаем сжимать кнопки, они всегда должны быть видны */
  flex-shrink: 0;

  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 50px 50px; /* Фиксированная высота кнопок */
  gap: 8px;
  max-width: 300px;

  /* Доп. отступ снизу для надежности */
  padding-bottom: 5px;
}

.t-btn {
  background: linear-gradient(to bottom, #34495e, #2c3e50);
  border: 1px solid #1a252f;
  border-top: 1px solid #4e6075;
  border-radius: 6px;
  color: #ecf0f1;
  font-size: 18px;
  display: flex; align-items: center; justify-content: center;
  cursor: pointer; box-shadow: 0 3px 0 #151f28;
  -webkit-user-select: none;
          user-select: none; touch-action: manipulation;
}
.t-btn:active { transform: translateY(2px); box-shadow: 0 1px 0 #151f28; background: #2c3e50; }

/* Позиционирование */
/* Верхний ряд */
.btn-hard-drop { grid-column: 1; grid-row: 1; } /* НОВАЯ КНОПКА: Слева сверху */
.btn-rotate    { grid-column: 2; grid-row: 1; } /* В центре сверху */

/* Нижний ряд */
.btn-left      { grid-column: 1; grid-row: 2; }
.btn-down      { grid-column: 2; grid-row: 2; } /* Плавный спуск */
.btn-right     { grid-column: 3; grid-row: 2; }

.btn-hard-drop {
  background: linear-gradient(to bottom, rgba(138, 42, 31, 0.8), rgba(105, 30, 23, 0.8)); /* Красный оттенок для опасного действия */
  border-color: #641e16;
  margin: 5px 10px 10px 5px;
  color: #cdcece;

}

/* --- РЕЖИМ БЕЗ КНОПОК УПРАВЛЕНИЯ --- */
.tetris-board-container.no-controls .tetris-main-area {
  margin-bottom: 0; /* Убираем отступ снизу, позволяя стакану растянуться на весь экран */
}

/* --- НОВЫЙ ЭКРАН РЕЗУЛЬТАТОВ (Стиль Досье/Папки) --- */

.tr-report-overlay {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.85); /* Затемнение фона */
  backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;
  align-items: center; /* Центрируем по вертикали */
  z-index: 100;
  animation: fadeIn 0.3s ease-out;
  padding: 20px;
  box-sizing: border-box;
}

.tr-report-card {
  width: 100%;
  max-width: 360px;

  /* Стиль папки Manila */
  background-color: #f0e6cf;
  background-image: radial-gradient(circle at center, transparent 40%, rgba(0,0,0,0.05) 100%);

  padding: 30px 25px;
  border-radius: 4px;
  box-shadow:
    0 2px 5px rgba(0,0,0,0.2),
    0 20px 50px rgba(0,0,0,0.8),
    inset 0 0 60px rgba(139, 69, 19, 0.1);

  transform: rotate(-1deg);
  font-family: 'Courier New', Courier, monospace;
  position: relative;
  text-align: left;
  color: #222;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* Скрепка */
.tr-report-card::before {
  content: '';
  position: absolute;
  top: -12px; left: 50%; transform: translateX(-50%);
  width: 14px; height: 40px;
  background: linear-gradient(90deg, #bbb, #ddd, #bbb);
  border-radius: 20px;
  box-shadow: 1px 2px 3px rgba(0,0,0,0.3);
  z-index: 10;
}

/* Водяной знак */
.tr-watermark {
  position: absolute;
  top: 50%; left: 50%;
  transform: translate(-50%, -50%) rotate(-45deg);
  font-size: 60px;
  font-weight: 900;
  color: rgba(0,0,0,0.04);
  pointer-events: none;
  border: 4px solid rgba(0,0,0,0.04);
  padding: 10px 30px;
  white-space: nowrap;
}

/* Заголовок */
.tr-report-header {
  border-bottom: 3px solid #333;
  margin-bottom: 20px;
  padding-bottom: 10px;
  text-align: center;
  position: relative;
  z-index: 2;
}

.tr-report-title {
  font-size: 22px;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #1a1a1a;
}

/* Сетка статистики */
.tr-stats-grid {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 20px;
  position: relative;
  z-index: 2;
}

.tr-stat-row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  border-bottom: 1px solid rgba(0,0,0,0.15);
  padding-bottom: 4px;
}

.tr-stat-label {
  font-size: 13px;
  font-weight: 700;
  color: #666;
  text-transform: uppercase;
}

.tr-stat-value {
  font-size: 20px;
  font-weight: 900;
  color: #111;
}
.tr-stat-value.rank-text {
  font-size: 16px;
  text-decoration: underline;
}

/* Штамп */
.tr-result-stamp {
  margin: 10px auto 20px auto;
  padding: 8px 20px;
  font-size: 28px;
  font-weight: 900;
  text-transform: uppercase;
  border: 5px double;
  border-radius: 4px;
  display: inline-block;
  transform: rotate(-10deg);
  opacity: 0.9;
  align-self: center;
  animation: stampDrop 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
}

.tr-stamp-ok { color: #15803d; border-color: #15803d; }
.tr-stamp-fail { color: #b91c1c; border-color: #b91c1c; }

@keyframes stampDrop {
  0% { transform: rotate(-10deg) scale(3); opacity: 0; }
  100% { transform: rotate(-10deg) scale(1); opacity: 0.9; }
}

/* Кнопки */
.tr-btn-group {
  margin-top: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 10;
}

.tr-btn {
  border: none;
  padding: 14px 0;
  width: 100%;
  font-family: inherit;
  font-weight: 900;
  font-size: 16px;
  text-transform: uppercase;
  letter-spacing: 1px;
  cursor: pointer;
  box-shadow: 0 3px 0 rgba(0,0,0,0.3);
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: transform 0.1s;
}

.tr-btn:active {
  transform: translateY(2px);
  box-shadow: 0 1px 0 rgba(0,0,0,0.3);
}

.tr-btn-primary {
  background: #222;
  color: #f0e6cf;
}

.tr-btn-secondary {
  background: transparent;
  border: 2px solid #444;
  color: #333;
  box-shadow: none;
}
.tr-btn-secondary:active {
  background: rgba(0,0,0,0.05);
}

/* Фикс для Лидерборда внутри светлой папки */
.tr-report-card .unified-leaderboard {
  background: rgba(0,0,0,0.05); /* Светлый фон */
  border: 1px solid rgba(0,0,0,0.1);
  color: #333;
  margin-top: 0;
}
.tr-report-card .ul-title { color: #555; text-shadow: none; }
.tr-report-card .ul-item { background: rgba(255,255,255,0.5); color: #333; }
.tr-report-card .ul-item.is-me { background: rgba(251, 191, 36, 0.3); border-left-color: #b45309; color: #000; }
.tr-report-card .ul-score { color: #15803d; }

/* --- ВИЗУАЛЬНЫЕ ЭФФЕКТЫ БОНУСОВ --- */
.tetris-fx {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 50;
  pointer-events: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  animation: fx-float-up 2.5s cubic-bezier(0.25, 1, 0.5, 1) forwards;
  text-shadow: 0 4px 10px rgba(0,0,0,0.8);
  white-space: nowrap;
}

/* Эффект: Убранные 4 линии (Тетрис) */
.fx-tetris .fx-text {
  color: #f1c40f;
  font-size: 28px;
  font-weight: 900;
  letter-spacing: 2px;
  animation: fx-pulse 0.5s infinite alternate;
}
.fx-tetris .fx-points {
  color: #fff;
  font-size: 36px;
  font-weight: bold;
  text-shadow: 0 2px 5px rgba(0,0,0,1);
}

/* Эффект: Полная очистка поля */
.fx-perfect_clear .fx-text {
  color: #00ffff;
  font-size: 24px;
  font-weight: 900;
  letter-spacing: 1px;
  animation: fx-rainbow 1.5s infinite linear;
}
.fx-perfect_clear .fx-points {
  color: #fff;
  font-size: 44px;
  font-weight: bold;
  text-shadow: 0 2px 5px rgba(0,0,0,1);
}

/* Эффект: Убранные 3 линии (Тройной) - Спокойный, без свечения и пульсации */
.fx-triple .fx-text {
  color: #d3dade; /* Благородный серебристо-серый цвет */
  font-size: 24px; /* Чуть меньше, чем у Тетриса (28px) */
  font-weight: 700;
  letter-spacing: 1px;
  text-shadow: 0 2px 4px rgba(0,0,0,0.8); /* Обычная тень для читаемости, без неонового блюра */
}
.fx-triple .fx-points {
  color: #ecf0f1;
  font-size: 28px;
  font-weight: bold;
  text-shadow: 0 2px 4px rgba(0,0,0,0.8);
}

/* Анимация: Взлет, задержка и угасание текста */
@keyframes fx-float-up {
  0% { transform: translate(-50%, 0%); opacity: 0; scale: 0.5; }
  10% { transform: translate(-50%, -50%); opacity: 1; scale: 1.2; }
  20% { transform: translate(-50%, -50%); opacity: 1; scale: 1; }
  80% { transform: translate(-50%, -80%); opacity: 1; scale: 1; }
  100% { transform: translate(-50%, -100%); opacity: 0; scale: 0.8; }
}

/* Пульсация света */
@keyframes fx-pulse {
  from { text-shadow: 0 0 10px #f1c40f, 0 0 20px #f1c40f; }
  to { text-shadow: 0 0 20px #e67e22, 0 0 40px #e67e22; }
}

/* Переливание цветами */
@keyframes fx-rainbow {
  0% { filter: hue-rotate(0deg); text-shadow: 0 0 15px #00ffff; }
  100% { filter: hue-rotate(360deg); text-shadow: 0 0 15px #00ffff; }
}

/* Эффект: 2 линии (Двойной) */
.fx-double .fx-points {
  color: #aeb6bf;
  font-size: 24px;
  font-weight: bold;
  text-shadow: 0 1px 3px rgba(0,0,0,0.8);
  opacity: 0.8;
}

/* Эффект: 1 линия (Одинарный) */
.fx-single .fx-points {
  color: #7f8c8d;
  font-size: 18px;
  font-weight: bold;
  text-shadow: 0 1px 2px rgba(0,0,0,0.6);
  opacity: 0.6;
}

/* --- АНИМАЦИЯ ТРЯСКИ СТАКАНА --- */
.tetris-shake {
  animation: tetris-bump 0.2s ease-out;
}

/* Высокочастотная микровибрация (очень упругая, уменьшенная амплитуда, больше шагов) */
@keyframes tetris-bump {
  0%   { transform: translateY(0); }
  12%  { transform: translateY(0.8px); }
  25%  { transform: translateY(-0.5px); }
  37%  { transform: translateY(0.6px); }
  50%  { transform: translateY(-0.4px); }
  62%  { transform: translateY(0.4px); }
  75%  { transform: translateY(-0.2px); }
  87%  { transform: translateY(0.2px); }
  100% { transform: translateY(0); }
}

/* --- СВЕТОВОЙ БЛИК ТОЛЬКО ПО 1-ПИКСЕЛЬНОЙ ОКАНТОВКЕ --- */
.tetris-shake::after {
  content: '';
  position: absolute;
  /* Ложимся строго поверх 1px рамки самого стакана */
  top: 0; left: -1px; right: -1px; bottom: -1px;

  /* Делаем сам блик той же толщины (1px), без фона внутри */
  border: 1px solid #ffffff;
  border-top: none; /* У стакана нет верхней грани */

  /* Придаем 1-пиксельной полосе неоновый блеск */
  box-shadow:
      inset 0 0 6px rgba(0, 255, 255, 0.8),
      0 0 6px rgba(0, 255, 255, 0.8),
      inset 0 0 2px #fff,
      0 0 2px #fff;

  z-index: 100;
  pointer-events: none;

  /* Создаем маску-прорезь. Всё скрыто, кроме тонкой диагональной полосы */
  mask-image: linear-gradient(
      45deg,
      transparent 48%,
      black 49%,
      black 51%,
      transparent 52%
  );

  /* Делаем маску гигантской (2000px), чтобы прорезь была ровной и длинной */
  mask-size: 2000px 2000px;
  mask-repeat: no-repeat;

  /* Проносим эту прорезь снизу вверх за 0.2с */
  animation: border-spark 0.4s linear forwards;
}

/* Анимация движения маски от левого нижнего угла к правому верхнему */
@keyframes border-spark {
  0% {
    mask-position: -500px 500px;
  }
  100% {
    mask-position: 500px -1000px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/arcade/games/tetris/Tetris.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA,8BAA8B;AAC9B;EACE,eAAe;;EAEf,qBAAqB;EACrB,QAAQ;EACR,SAAS;EACT,gCAAgC,EAAE,6CAA6C;;EAE/E,yCAAyC;EACzC,WAAW,QAAQ,8BAA8B;EACjD,gBAAgB,GAAG,wBAAwB;;EAE3C,yBAAyB,EAAE,qCAAqC;EAChE,iBAAiB,EAAE,6DAA6D;;EAEhF,+BAA+B;EAC/B,sBAAsB;EACtB;;uEAEqE;EACrE,0BAA0B;;EAE1B,yBAAyB,EAAE,kBAAkB;EAC7C,mBAAmB,QAAQ,qBAAqB;;EAEhD,sCAAsC;EACtC;;;iCAG+B;;EAE/B,iDAAiD;EACjD,qEAAqE;EACrE,4BAA4B;;EAE5B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;;EAE9B,cAAc;EACd,qCAAqC;EACrC,aAAa;EACb,yBAAiB;UAAjB,iBAAiB;EACjB,sBAAsB;;IAEpB,uDAAuD;IACvD,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,cAAc;AACd;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB,EAAE,oCAAoC;EACxD,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS,EAAE,wCAAwC;EACnD,uBAAuB;;EAEvB;mEACiE;EACjE,uBAAuB;;EAEvB,WAAW;EACX,SAAO,OAAO,2CAA2C;EACzD,aAAa,EAAE,wBAAwB;;EAEvC,kBAAkB;EAClB,mBAAmB,EAAE,gCAAgC;AACvD;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;;EAEhB,aAAa;;EAEb,kEAAkE;EAClE,YAAY;;EAEZ,mDAAmD;EACnD,cAAc;;EAEd,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA,6EAA6E;;AAE7E,iCAAiC;AACjC;EACE,WAAW;EACX,kBAAkB,EAAE,QAAQ;EAC5B;;uEAEqE;;EAErE,qDAAqD;EACrD,iEAAiE;EACjE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,8DAA8D;AAChE;;AAEA,6BAA6B;;AAE7B,0CAA0C;AAC1C;EACE,iCAAiC;EACjC;;;6BAG2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B,EAAE,2CAA2C;AAC1E;;AAEA,kEAAkE;AAClE;EACE;;;;;;iBAMe;EACf,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,kBAAkB,EAAE,QAAQ,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EACzF,eAAe,EAAE,uBAAuB;EACxC,gBAAgB,EAAE,uDAAuD;EACzE,gBAAgB,EAAE,cAAc,EAAE,YAAY;AAChD;;AAEA,4DAA4D;AAC5D;EACE,yBAAyB;EACzB;;;;oBAIkB;AACpB;AACA;EACE,YAAY;EACZ,kBAAkB,EAAE,QAAQ,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EACzF,eAAe,EAAE,uBAAuB;EACxC,gBAAgB,EAAE,yDAAyD;EAC3E,sBAAsB,EAAE,iBAAiB;AAC3C;;AAEA,qDAAqD;AACrD;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;AACA;EACE,WAAW,EAAE,kBAAkB;EAC/B,QAAQ,EAAE,SAAS,EAAE,UAAU,EAAE,WAAW;EAC5C,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA,6DAA6D;AAC7D;EACE,yBAAyB;EACzB,8DAA8D;AAChE;AACA;EACE,WAAW,EAAE,kBAAkB;EAC/B,MAAM,EAAE,SAAS,EAAE,UAAU,EAAE,YAAY;EAC3C,kCAAkC;EAClC,sCAAsC;EACtC,uCAAuC;AACzC;;AAEA,sDAAsD;AACtD;EACE,mBAAmB;EACnB,wGAAwG;AAC1G;;AAEA,uEAAuE;AACvE;EACE;;;;;iBAKe;AACjB;AACA;EACE,aAAa;EACb,kBAAkB,EAAE,QAAQ,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EACzF,eAAe,EAAE,uBAAuB;EACxC,gBAAgB,EAAE,4DAA4D;EAC9E,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB;AAChE;;AAEA,oDAAoD;AACpD;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;AACA;EACE,WAAW,EAAE,kBAAkB,EAAE,QAAQ;EACzC;;uFAEqF;EACrF,UAAU;AACZ;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAE,uEAAuE;;EAElF,YAAY;EACZ,WAAW,EAAE,gEAAgE;EAC7E,cAAc;;EAEd,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ,EAAE,gDAAgD;EAC1D,WAAW;AACb;;AAEA;EACE,eAAe,EAAE,gCAAgC;EACjD,gBAAgB;EAChB,cAAc,EAAE,mDAAmD;EACnE,yBAAyB;EACzB,qBAAqB;EACrB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,eAAe,EAAE,gCAAgC;EACjD,gBAAgB;EAChB,cAAc,EAAE,iCAAiC;EACjD,sCAAsC;EACtC,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,+CAA+C;EAC/C,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;;EAEd,YAAY;EACZ,UAAU;EACV,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;;EAEf,iDAAiD;EACjD,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA,iCAAiC;AACjC;EACE,0BAA0B;EAC1B,gBAAgB,EAAE,+BAA+B;EACjD,yBAAyB;AAC3B;;AAEA,wCAAwC;AACxC;EACE,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;EAC3B,WAAW;AACb;AACA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,yCAAyC;AACzC,kEAAkE;AAClE;EACE,yBAAyB,EAAE,kCAAkC;EAC7D,yBAAyB;EACzB,gBAAgB,EAAE,+CAA+C;EACjE,cAAc,EAAE,iDAAiD;EACjE,eAAe,EAAE,yBAAyB;AAC5C;;AAEA,iEAAiE;AACjE;EACE,yBAAyB;AAC3B;;AAEA,mCAAmC;AACnC;EACE,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,oBAAoB,EAAE,yEAAyE;AACjG;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,YAAY;EACZ,eAAe;;EAEf,8BAA8B,EAAE,8CAA8C;EAC9E,yBAAyB,EAAE,yCAAyC;EACpE,kBAAkB;;EAElB,sEAAsE;EACtE,2EAA2E;;EAE3E,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,kCAAkC;EAClC,WAAW;EACX,YAAY;EACZ,QAAQ;AACV;AACA,aAAa,WAAW,EAAE,YAAY,EAAE;;AAExC,uBAAuB;AACvB;EACE,WAAW;EACX,2DAA2D;EAC3D,cAAc;;EAEd,aAAa;EACb,kCAAkC;EAClC,6BAA6B,EAAE,gCAAgC;EAC/D,QAAQ;EACR,gBAAgB;;EAEhB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,wDAAwD;EACxD,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,eAAe,EAAE,2BAA2B;EAC5C,yBAAiB;UAAjB,iBAAiB,EAAE,0BAA0B;AAC/C;AACA,gBAAgB,0BAA0B,EAAE,2BAA2B,EAAE,mBAAmB,EAAE;;AAE9F,qBAAqB;AACrB,gBAAgB;AAChB,iBAAiB,cAAc,EAAE,WAAW,EAAE,EAAE,+BAA+B;AAC/E,iBAAiB,cAAc,EAAE,WAAW,EAAE,EAAE,oBAAoB;;AAEpE,eAAe;AACf,iBAAiB,cAAc,EAAE,WAAW,EAAE;AAC9C,iBAAiB,cAAc,EAAE,WAAW,EAAE,EAAE,kBAAkB;AAClE,iBAAiB,cAAc,EAAE,WAAW,EAAE;;AAE9C;EACE,sFAAsF,EAAE,0CAA0C;EAClI,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;;AAEhB;;AAEA,wCAAwC;AACxC;EACE,gBAAgB,EAAE,qEAAqE;AACzF;;AAEA,wDAAwD;;AAExD;EACE,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,+BAA+B,EAAE,oBAAoB;EACrD,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB,EAAE,4BAA4B;EACjD,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;;EAEhB,uBAAuB;EACvB,yBAAyB;EACzB,2FAA2F;;EAE3F,kBAAkB;EAClB,kBAAkB;EAClB;;;yCAGuC;;EAEvC,wBAAwB;EACxB,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU,EAAE,SAAS,EAAE,2BAA2B;EAClD,WAAW,EAAE,YAAY;EACzB,oDAAoD;EACpD,mBAAmB;EACnB,uCAAuC;EACvC,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,QAAQ,EAAE,SAAS;EACnB,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,kCAAkC;EAClC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA,UAAU;AACV;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,0EAA0E;AAC5E;;AAEA,eAAe,cAAc,EAAE,qBAAqB,EAAE;AACtD,iBAAiB,cAAc,EAAE,qBAAqB,EAAE;;AAExD;EACE,KAAK,kCAAkC,EAAE,UAAU,EAAE;EACrD,OAAO,kCAAkC,EAAE,YAAY,EAAE;AAC3D;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,mCAAmC;EACnC,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,4BAA4B;AAC9B;;AAEA,6CAA6C;AAC7C;EACE,4BAA4B,EAAE,gBAAgB;EAC9C,iCAAiC;EACjC,WAAW;EACX,aAAa;AACf;AACA,4BAA4B,WAAW,EAAE,iBAAiB,EAAE;AAC5D,2BAA2B,iCAAiC,EAAE,WAAW,EAAE;AAC3E,iCAAiC,mCAAmC,EAAE,0BAA0B,EAAE,WAAW,EAAE;AAC/G,4BAA4B,cAAc,EAAE;;AAE5C,uCAAuC;AACvC;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kEAAkE;EAClE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;AAC7C;AACA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA,gCAAgC;AAChC;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;AAC5C;AACA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA,6EAA6E;AAC7E;EACE,cAAc,EAAE,sCAAsC;EACtD,eAAe,EAAE,sCAAsC;EACvD,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC,EAAE,qDAAqD;AAC/F;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA,gDAAgD;AAChD;EACE,KAAK,8BAA8B,EAAE,UAAU,EAAE,UAAU,EAAE;EAC7D,MAAM,gCAAgC,EAAE,UAAU,EAAE,UAAU,EAAE;EAChE,MAAM,gCAAgC,EAAE,UAAU,EAAE,QAAQ,EAAE;EAC9D,MAAM,gCAAgC,EAAE,UAAU,EAAE,QAAQ,EAAE;EAC9D,OAAO,iCAAiC,EAAE,UAAU,EAAE,UAAU,EAAE;AACpE;;AAEA,oBAAoB;AACpB;EACE,OAAO,+CAA+C,EAAE;EACxD,KAAK,+CAA+C,EAAE;AACxD;;AAEA,wBAAwB;AACxB;EACE,KAAK,wBAAwB,EAAE,6BAA6B,EAAE;EAC9D,OAAO,0BAA0B,EAAE,6BAA6B,EAAE;AACpE;;AAEA,8BAA8B;AAC9B;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,sCAAsC;EACtC,YAAY;AACd;;AAEA,gCAAgC;AAChC;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,sCAAsC;EACtC,YAAY;AACd;;AAEA,oCAAoC;AACpC;EACE,oCAAoC;AACtC;;AAEA,uFAAuF;AACvF;EACE,OAAO,wBAAwB,EAAE;EACjC,OAAO,4BAA4B,EAAE;EACrC,OAAO,6BAA6B,EAAE;EACtC,OAAO,4BAA4B,EAAE;EACrC,OAAO,6BAA6B,EAAE;EACtC,OAAO,4BAA4B,EAAE;EACrC,OAAO,6BAA6B,EAAE;EACtC,OAAO,4BAA4B,EAAE;EACrC,OAAO,wBAAwB,EAAE;AACnC;;AAEA,2DAA2D;AAC3D;EACE,WAAW;EACX,kBAAkB;EAClB,mDAAmD;EACnD,MAAM,EAAE,UAAU,EAAE,WAAW,EAAE,YAAY;;EAE7C,0DAA0D;EAC1D,yBAAyB;EACzB,gBAAgB,EAAE,gCAAgC;;EAElD,+CAA+C;EAC/C;;;;kBAIgB;;EAEhB,YAAY;EACZ,oBAAoB;;EAEpB,wEAAwE;EAQxE;;;;;;GAMC;;EAED,0EAA0E;EAE1E,wBAAwB;EAExB,sBAAsB;;EAEtB,6CAA6C;EAC7C,4CAA4C;AAC9C;;AAEA,sEAAsE;AACtE;EACE;IAEE,2BAA2B;EAC7B;EACA;IAEE,4BAA4B;EAC9B;AACF","sourcesContent":["/* games/tetris/Tetris.css */\r\n\r\n@keyframes fadeIn {\r\n  from { opacity: 0; }\r\n  to { opacity: 1; }\r\n}\r\n\r\n/* --- ГЛАВНЫЙ КОНТЕЙНЕР --- */\r\n.tetris-board-container {\r\n  position: fixed;\r\n\r\n  /* 1. ЦЕНТРИРОВАНИЕ */\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%); /* Сдвигаем точку привязки в центр элемента */\r\n\r\n  /* 2. РАЗМЕРЫ И ОТСТУПЫ ОТ КРАЕВ ЭКРАНА */\r\n  width: 96vw;       /* 2% отступа слева и справа */\r\n  max-width: 400px;  /* Максимальная ширина */\r\n\r\n  height: calc(100% - 20px); /* 10px отступа сверху и 10px снизу */\r\n  max-height: 900px; /* На очень высоких экранах не растягивать до бесконечности */\r\n\r\n  /* 3. МАТЕРИАЛЬНОСТЬ (КОРПУС) */\r\n  background-color: #222;\r\n  background-image:\r\n    linear-gradient(rgba(255,255,255,0.02) 1px, transparent 1px),\r\n    linear-gradient(90deg, rgba(255,255,255,0.02) 1px, transparent 1px);\r\n  background-size: 20px 20px;\r\n\r\n  border: 4px solid #2c3e50; /* Рамка корпуса */\r\n  border-radius: 16px;       /* Скругление углов */\r\n\r\n  /* Тени: контур, блик, глубокая тень */\r\n  box-shadow:\r\n      0 0 0 1px #000,\r\n      inset 0 1px 0 rgba(255,255,255,0.1),\r\n      0 20px 60px rgba(0,0,0,0.9);\r\n\r\n  /* 4. ВНУТРЕННИЕ ОТСТУПЫ (СТЕНКИ ВОКРУГ ЭКРАНА) */\r\n  /* Сверху 15, Снизу 15, По бокам 20 - создает ощущение рамок экрана */\r\n  padding: 15px 12px 15px 12px;\r\n\r\n  /* FLEX LAYOUT */\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n\r\n  color: #bdc3c7;\r\n  font-family: 'Courier New', monospace;\r\n  z-index: 6000;\r\n  user-select: none;\r\n  box-sizing: border-box;\r\n\r\n    /* Блокируем стандартные жесты браузера (скролл, зум) */\r\n    touch-action: none;\r\n    overflow: hidden;\r\n}\r\n\r\n/* ЗАГОЛОВОК */\r\n.tetris-header {\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 8px; /* Небольшой отступ от экрана игры */\r\n  padding: 6px 10px;\r\n  background: #151515;\r\n  border-bottom: 1px solid #333;\r\n  border-radius: 4px;\r\n  flex-shrink: 0;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.tetris-title {\r\n  font-weight: 900;\r\n  text-transform: uppercase;\r\n  color: #e67e22;\r\n  letter-spacing: 1px;\r\n  font-size: 14px;\r\n  text-shadow: 0 1px 2px black;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  margin-right: 10px;\r\n}\r\n\r\n.tetris-timer {\r\n  font-family: monospace;\r\n  font-weight: bold;\r\n  color: #888;\r\n  font-size: 14px;\r\n}\r\n\r\n/* ИГРОВАЯ ЗОНА */\r\n.tetris-main-area {\r\n  display: flex;\r\n  gap: 12px; /* Расстояние между Колодцем и Панелью */\r\n  justify-content: center;\r\n\r\n  /* ИЗМЕНЕНО: Было center. Ставим flex-start,\r\n     чтобы и колодец, и сайдбар прижимались к верхней грани зоны. */\r\n  align-items: flex-start;\r\n\r\n  width: 100%;\r\n  flex: 1;      /* Занимаем всё доступное место по высоте */\r\n  min-height: 0; /* Разрешаем сжиматься */\r\n\r\n  position: relative;\r\n  margin-bottom: 10px; /* Отступ до кнопок управления */\r\n}\r\n\r\n/* СЕТКА (КОЛОДЕЦ) */\r\n.tetris-grid {\r\n  background: #0e0e0e;\r\n  border: 1px solid #444;\r\n  border-top: none;\r\n\r\n  display: grid;\r\n\r\n  /* Пытаемся занять всю высоту, пока не упремся в maxHeight из JS */\r\n  height: 100%;\r\n\r\n  /* ЖЕСТКИЙ ЗАПРЕТ на сплющивание Flex-контейнером */\r\n  flex-shrink: 0;\r\n\r\n  box-shadow: inset 0 0 30px rgba(0,0,0,0.9);\r\n  position: relative;\r\n}\r\n\r\n/* Media query больше не нужна - calc() уже учитывает ограничения по высоте */\r\n\r\n/* Фоновая сетка внутри колодца */\r\n.tetris-grid::before {\r\n  content: '';\r\n  position: absolute; inset: 0;\r\n  background-image:\r\n    linear-gradient(rgba(255,255,255,0.05) 1px, transparent 1px),\r\n    linear-gradient(90deg, rgba(255,255,255,0.05) 1px, transparent 1px);\r\n\r\n  /* Используем CSS-переменные, передаваемые из React */\r\n  background-size: var(--bg-size-x, 12.5%) var(--bg-size-y, 6.666%);\r\n  pointer-events: none;\r\n}\r\n\r\n.tetris-cell {\r\n  width: 100%;\r\n  height: 100%;\r\n  box-sizing: border-box;\r\n  /* Границы ячеек убраны для чистоты, оставим только у блоков */\r\n}\r\n\r\n/* --- МАТЕРИАЛЫ БЛОКОВ --- */\r\n\r\n/* Базовый слой 3D объема для всех фигур */\r\n.cell-filled {\r\n  border: 1px solid rgba(0,0,0,0.3);\r\n  box-shadow:\r\n    inset 2px 2px 2px rgba(255,255,255,0.3),\r\n    inset -2px -2px 3px rgba(0,0,0,0.5),\r\n    0 4px 8px rgba(0,0,0,0.4);\r\n  border-radius: 2px;\r\n  position: relative;\r\n  overflow: hidden;\r\n  container-type: inline-size; /* <-- ДОБАВЛЕНО ДЛЯ ДИНАМИЧЕСКИХ ШРИФТОВ */\r\n}\r\n\r\n/* 1. I (Палка) - ТЕПЕРЬ ЗЕРКАЛЬНОЕ ЗОЛОТО (Самая ценная фигура) */\r\n.type-I {\r\n  background: linear-gradient(135deg,\r\n    #ffeaa7 0%,\r\n    #f1c40f 25%,\r\n    #ffffff 45%,\r\n    #f3ce12 55%,\r\n    #d4af37 80%,\r\n    #a67a0b 100%);\r\n  border: 1px solid #996515;\r\n}\r\n.type-I::after {\r\n  content: '999';\r\n  position: absolute; inset: 0; display: flex; align-items: center; justify-content: center;\r\n  font-size: 11px; /* Увеличенный фолбэк */\r\n  font-size: 45cqw; /* <-- Было 35, стало 45 (крупнее, но 3 цифры влезут) */\r\n  font-weight: 900; color: #8c5c13; opacity: 0.6;\r\n}\r\n\r\n/* 2. J (Крюк) - ТЕПЕРЬ ДЕРЕВЯННЫЕ ЯЩИКИ (Вместо Т-фигуры) */\r\n.type-J {\r\n  background-color: #7b502a;\r\n  background-image: repeating-linear-gradient(90deg,\r\n    rgba(0,0,0,0.1) 0px,\r\n    rgba(0,0,0,0.1) 1px,\r\n    transparent 1px,\r\n    transparent 8px);\r\n}\r\n.type-J::after {\r\n  content: '⚠';\r\n  position: absolute; inset: 0; display: flex; align-items: center; justify-content: center;\r\n  font-size: 18px; /* Увеличенный фолбэк */\r\n  font-size: 80cqw; /* <-- Было 60, стало 80 (один символ отлично впишется) */\r\n  color: rgba(0,0,0,0.2); font-weight: bold;\r\n}\r\n\r\n/* 3. L (Г-фигура) - ОРУЖЕЙНЫЙ КЕЙС (Без изменений) */\r\n.type-L {\r\n  background: linear-gradient(135deg, #455a64 0%, #263238 100%);\r\n  border-color: #1c272b;\r\n}\r\n.type-L::after {\r\n  content: ''; position: absolute;\r\n  top: 25%; left: 15%; width: 70%; height: 20%;\r\n  background: rgba(255,255,255,0.7);\r\n  border-radius: 1px;\r\n}\r\n\r\n/* 4. O (Квадрат) - ТЕПЕРЬ КАРТОННЫЕ КОРОБКИ (Вместо Палки) */\r\n.type-O {\r\n  background-color: #c6a664;\r\n  background-image: linear-gradient(to bottom, #d2b48c, #b89a5b);\r\n}\r\n.type-O::after {\r\n  content: ''; position: absolute;\r\n  top: 0; left: 30%; width: 40%; height: 100%;\r\n  background: rgba(139, 69, 19, 0.2);\r\n  border-left: 1px solid rgba(0,0,0,0.1);\r\n  border-right: 1px solid rgba(0,0,0,0.1);\r\n}\r\n\r\n/* 5. S (Зигзаг) - ПОЛИЦЕЙСКАЯ ЛЕНТА (Без изменений) */\r\n.type-S {\r\n  background: #fbc02d;\r\n  background-image: repeating-linear-gradient(-45deg, #222 0, #222 6px, transparent 6px, transparent 12px);\r\n}\r\n\r\n/* 6. T (Т-образная) - ТЕПЕРЬ ЗЕРКАЛЬНОЕ СЕРЕБРО (Вторая по важности) */\r\n.type-T {\r\n  background: linear-gradient(135deg,\r\n    #95a5a6 0%,\r\n    #ffffff 40%,\r\n    #eeeeee 50%,\r\n    #bdc3c7 60%,\r\n    #7f8c8d 100%);\r\n}\r\n.type-T::after {\r\n  content: 'AG';\r\n  position: absolute; inset: 0; display: flex; align-items: center; justify-content: center;\r\n  font-size: 13px; /* Увеличенный фолбэк */\r\n  font-size: 55cqw; /* <-- Было 40, стало 55 (две буквы будут выглядеть сочно) */\r\n  font-weight: 900; color: rgba(0,0,0,0.25); letter-spacing: 1px;\r\n}\r\n\r\n/* 7. Z (Зигзаг) - ПАКЕТЫ ВЕЩДОКОВ (Без изменений) */\r\n.type-Z {\r\n  background: linear-gradient(135deg, #ffffff 0%, #f0f0f0 100%);\r\n  border-color: #bdc3c7;\r\n}\r\n.type-Z::before {\r\n  content: ''; position: absolute; inset: 0;\r\n  background:\r\n    linear-gradient(115deg, transparent 40%, rgba(255,255,255,0.9) 47%, rgba(255,255,255,0.9) 52%, transparent 60%),\r\n    linear-gradient(25deg, transparent 20%, rgba(255,255,255,0.4) 25%, transparent 30%);\r\n  z-index: 1;\r\n}\r\n\r\n/* --- БОКОВАЯ ПАНЕЛЬ --- */\r\n.tetris-sidebar {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 18px; /* Чуть увеличили отступ, чтобы блоки не слипались при большем шрифте */\r\n\r\n  height: 100%;\r\n  width: 65px; /* Расширили на 5px для комфортного размещения крупного шрифта */\r\n  flex-shrink: 0;\r\n\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n}\r\n\r\n/* Новые минималистичные группы статистики */\r\n.stat-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  text-align: center;\r\n  gap: 4px; /* Чуть больше воздуха между подписью и цифрой */\r\n  width: 100%;\r\n}\r\n\r\n.sb-label {\r\n  font-size: 13px; /* Увеличили шрифт (было 11px) */\r\n  font-weight: 800;\r\n  color: #7f8c8d; /* Теплый, спокойный серый цвет, в тон интерфейсу */\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.5px;\r\n  text-shadow: 0 1px 2px rgba(0,0,0,0.8);\r\n  white-space: nowrap;\r\n}\r\n\r\n.sb-val {\r\n  font-size: 19px; /* Увеличили цифры (было 16px) */\r\n  font-weight: 900;\r\n  color: #ecf0f1; /* Мягкий белый (не режет глаз) */\r\n  text-shadow: 0 2px 4px rgba(0,0,0,0.9);\r\n  line-height: 1;\r\n}\r\n\r\n/* --- КНОПКИ САЙДБАРА --- */\r\n.sidebar-btn {\r\n  /* Спокойный темно-серый цвет, без градиентов */\r\n  background-color: #4a4a52;\r\n  border: 1px solid #333;\r\n  border-radius: 6px;\r\n  color: #e0e0e0;\r\n\r\n  height: 32px;\r\n  padding: 0;\r\n  cursor: pointer;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-size: 18px;\r\n\r\n  /* Легкая аккуратная тень для отделения от фона */\r\n  box-shadow: 0 2px 0 #2a2a30;\r\n  transition: all 0.15s ease;\r\n}\r\n\r\n/* Нажатие на включенную кнопку */\r\n.sidebar-btn:active {\r\n  transform: translateY(2px);\r\n  box-shadow: none; /* Тень пропадает при нажатии */\r\n  background-color: #3d3d44;\r\n}\r\n\r\n/* Состояние: ПАУЗА (Сплошной зеленый) */\r\n.sidebar-btn.paused {\r\n  background-color: #27ae60;\r\n  border-color: #1e8449;\r\n  box-shadow: 0 2px 0 #145a32;\r\n  color: #fff;\r\n}\r\n.sidebar-btn.paused:active {\r\n  transform: translateY(2px);\r\n  box-shadow: none;\r\n  background-color: #219653;\r\n}\r\n\r\n/* Состояние: КНОПКИ СКРЫТЫ (Выключено) */\r\n/* Кнопка становится плоской и гаснет, сливаясь с фоном сайдбара */\r\n.sidebar-btn.controls-off {\r\n  background-color: #242428; /* Очень темный серый, почти фон */\r\n  border: 1px solid #1a1a1d;\r\n  box-shadow: none; /* Нет тени — кнопка плоская, а не вдавленная */\r\n  color: #4a4a52; /* Тусклая иконка в цвет выключенного состояния */\r\n  transform: none; /* Никакого сдвига вниз */\r\n}\r\n\r\n/* Легкая реакция на клик по выключенной кнопке (при включении) */\r\n.sidebar-btn.controls-off:active {\r\n  background-color: #2a2a30;\r\n}\r\n\r\n/* Увеличенная иконка контроллера */\r\n.icon-gamepad {\r\n  font-size: 24px;\r\n}\r\n\r\n/* ОВЕРЛЕЙ ПАУЗЫ */\r\n.tetris-paused-overlay {\r\n  position: absolute;\r\n  top: 0; left: 0; right: 0; bottom: 0;\r\n  background: rgba(0, 0, 0, 0.6);\r\n  backdrop-filter: blur(2px);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 40;\r\n  pointer-events: none; /* Чтобы клики не перехватывал, хотя кнопки и так заблокированы логикой */\r\n}\r\n\r\n.paused-text {\r\n  font-size: 24px;\r\n  font-weight: 900;\r\n  color: #fff;\r\n  letter-spacing: 4px;\r\n  text-transform: uppercase;\r\n  border: 2px solid #fff;\r\n  padding: 5px 15px;\r\n  transform: rotate(-5deg);\r\n  background: rgba(0,0,0,0.5);\r\n}\r\n\r\n/* БЛОК СЛЕДУЮЩЕЙ ФИГУРЫ */\r\n.next-piece-container {\r\n  width: 54px;\r\n  height: 54px;\r\n  margin-top: 2px;\r\n\r\n  background: rgba(0, 0, 0, 0.3); /* Легкое затемнение фона (эффект экранчика) */\r\n  border: 2px solid #4a4a52; /* Серая рамка в цвет кнопок интерфейса */\r\n  border-radius: 4px;\r\n\r\n  /* Внутренняя тень создает ощущение физического углубления в корпусе */\r\n  box-shadow: inset 0 2px 5px rgba(0,0,0,0.8), 0 1px 0 rgba(255,255,255,0.05);\r\n\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 3px;\r\n}\r\n\r\n.next-piece-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, 1fr);\r\n  grid-template-rows: repeat(4, 1fr);\r\n  width: 100%;\r\n  height: 100%;\r\n  gap: 1px;\r\n}\r\n.mini-cell { width: 100%; height: 100%; }\r\n\r\n/* --- УПРАВЛЕНИЕ --- */\r\n.tetris-controls {\r\n  width: 100%;\r\n  /* Запрещаем сжимать кнопки, они всегда должны быть видны */\r\n  flex-shrink: 0;\r\n\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr 1fr;\r\n  grid-template-rows: 50px 50px; /* Фиксированная высота кнопок */\r\n  gap: 8px;\r\n  max-width: 300px;\r\n\r\n  /* Доп. отступ снизу для надежности */\r\n  padding-bottom: 5px;\r\n}\r\n\r\n.t-btn {\r\n  background: linear-gradient(to bottom, #34495e, #2c3e50);\r\n  border: 1px solid #1a252f;\r\n  border-top: 1px solid #4e6075;\r\n  border-radius: 6px;\r\n  color: #ecf0f1;\r\n  font-size: 18px;\r\n  display: flex; align-items: center; justify-content: center;\r\n  cursor: pointer; box-shadow: 0 3px 0 #151f28;\r\n  user-select: none; touch-action: manipulation;\r\n}\r\n.t-btn:active { transform: translateY(2px); box-shadow: 0 1px 0 #151f28; background: #2c3e50; }\r\n\r\n/* Позиционирование */\r\n/* Верхний ряд */\r\n.btn-hard-drop { grid-column: 1; grid-row: 1; } /* НОВАЯ КНОПКА: Слева сверху */\r\n.btn-rotate    { grid-column: 2; grid-row: 1; } /* В центре сверху */\r\n\r\n/* Нижний ряд */\r\n.btn-left      { grid-column: 1; grid-row: 2; }\r\n.btn-down      { grid-column: 2; grid-row: 2; } /* Плавный спуск */\r\n.btn-right     { grid-column: 3; grid-row: 2; }\r\n\r\n.btn-hard-drop {\r\n  background: linear-gradient(to bottom, rgba(138, 42, 31, 0.8), rgba(105, 30, 23, 0.8)); /* Красный оттенок для опасного действия */\r\n  border-color: #641e16;\r\n  margin: 5px 10px 10px 5px;\r\n  color: #cdcece;\r\n\r\n}\r\n\r\n/* --- РЕЖИМ БЕЗ КНОПОК УПРАВЛЕНИЯ --- */\r\n.tetris-board-container.no-controls .tetris-main-area {\r\n  margin-bottom: 0; /* Убираем отступ снизу, позволяя стакану растянуться на весь экран */\r\n}\r\n\r\n/* --- НОВЫЙ ЭКРАН РЕЗУЛЬТАТОВ (Стиль Досье/Папки) --- */\r\n\r\n.tr-report-overlay {\r\n  position: absolute;\r\n  top: 0; left: 0; right: 0; bottom: 0;\r\n  background: rgba(0, 0, 0, 0.85); /* Затемнение фона */\r\n  backdrop-filter: blur(5px);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center; /* Центрируем по вертикали */\r\n  z-index: 100;\r\n  animation: fadeIn 0.3s ease-out;\r\n  padding: 20px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.tr-report-card {\r\n  width: 100%;\r\n  max-width: 360px;\r\n\r\n  /* Стиль папки Manila */\r\n  background-color: #f0e6cf;\r\n  background-image: radial-gradient(circle at center, transparent 40%, rgba(0,0,0,0.05) 100%);\r\n\r\n  padding: 30px 25px;\r\n  border-radius: 4px;\r\n  box-shadow:\r\n    0 2px 5px rgba(0,0,0,0.2),\r\n    0 20px 50px rgba(0,0,0,0.8),\r\n    inset 0 0 60px rgba(139, 69, 19, 0.1);\r\n\r\n  transform: rotate(-1deg);\r\n  font-family: 'Courier New', Courier, monospace;\r\n  position: relative;\r\n  text-align: left;\r\n  color: #222;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n}\r\n\r\n/* Скрепка */\r\n.tr-report-card::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: -12px; left: 50%; transform: translateX(-50%);\r\n  width: 14px; height: 40px;\r\n  background: linear-gradient(90deg, #bbb, #ddd, #bbb);\r\n  border-radius: 20px;\r\n  box-shadow: 1px 2px 3px rgba(0,0,0,0.3);\r\n  z-index: 10;\r\n}\r\n\r\n/* Водяной знак */\r\n.tr-watermark {\r\n  position: absolute;\r\n  top: 50%; left: 50%;\r\n  transform: translate(-50%, -50%) rotate(-45deg);\r\n  font-size: 60px;\r\n  font-weight: 900;\r\n  color: rgba(0,0,0,0.04);\r\n  pointer-events: none;\r\n  border: 4px solid rgba(0,0,0,0.04);\r\n  padding: 10px 30px;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Заголовок */\r\n.tr-report-header {\r\n  border-bottom: 3px solid #333;\r\n  margin-bottom: 20px;\r\n  padding-bottom: 10px;\r\n  text-align: center;\r\n  position: relative;\r\n  z-index: 2;\r\n}\r\n\r\n.tr-report-title {\r\n  font-size: 22px;\r\n  font-weight: 900;\r\n  text-transform: uppercase;\r\n  letter-spacing: 1px;\r\n  color: #1a1a1a;\r\n}\r\n\r\n/* Сетка статистики */\r\n.tr-stats-grid {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n  margin-bottom: 20px;\r\n  position: relative;\r\n  z-index: 2;\r\n}\r\n\r\n.tr-stat-row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: baseline;\r\n  border-bottom: 1px solid rgba(0,0,0,0.15);\r\n  padding-bottom: 4px;\r\n}\r\n\r\n.tr-stat-label {\r\n  font-size: 13px;\r\n  font-weight: 700;\r\n  color: #666;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.tr-stat-value {\r\n  font-size: 20px;\r\n  font-weight: 900;\r\n  color: #111;\r\n}\r\n.tr-stat-value.rank-text {\r\n  font-size: 16px;\r\n  text-decoration: underline;\r\n}\r\n\r\n/* Штамп */\r\n.tr-result-stamp {\r\n  margin: 10px auto 20px auto;\r\n  padding: 8px 20px;\r\n  font-size: 28px;\r\n  font-weight: 900;\r\n  text-transform: uppercase;\r\n  border: 5px double;\r\n  border-radius: 4px;\r\n  display: inline-block;\r\n  transform: rotate(-10deg);\r\n  opacity: 0.9;\r\n  align-self: center;\r\n  animation: stampDrop 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;\r\n}\r\n\r\n.tr-stamp-ok { color: #15803d; border-color: #15803d; }\r\n.tr-stamp-fail { color: #b91c1c; border-color: #b91c1c; }\r\n\r\n@keyframes stampDrop {\r\n  0% { transform: rotate(-10deg) scale(3); opacity: 0; }\r\n  100% { transform: rotate(-10deg) scale(1); opacity: 0.9; }\r\n}\r\n\r\n/* Кнопки */\r\n.tr-btn-group {\r\n  margin-top: auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n  z-index: 10;\r\n}\r\n\r\n.tr-btn {\r\n  border: none;\r\n  padding: 14px 0;\r\n  width: 100%;\r\n  font-family: inherit;\r\n  font-weight: 900;\r\n  font-size: 16px;\r\n  text-transform: uppercase;\r\n  letter-spacing: 1px;\r\n  cursor: pointer;\r\n  box-shadow: 0 3px 0 rgba(0,0,0,0.3);\r\n  border-radius: 4px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  transition: transform 0.1s;\r\n}\r\n\r\n.tr-btn:active {\r\n  transform: translateY(2px);\r\n  box-shadow: 0 1px 0 rgba(0,0,0,0.3);\r\n}\r\n\r\n.tr-btn-primary {\r\n  background: #222;\r\n  color: #f0e6cf;\r\n}\r\n\r\n.tr-btn-secondary {\r\n  background: transparent;\r\n  border: 2px solid #444;\r\n  color: #333;\r\n  box-shadow: none;\r\n}\r\n.tr-btn-secondary:active {\r\n  background: rgba(0,0,0,0.05);\r\n}\r\n\r\n/* Фикс для Лидерборда внутри светлой папки */\r\n.tr-report-card .unified-leaderboard {\r\n  background: rgba(0,0,0,0.05); /* Светлый фон */\r\n  border: 1px solid rgba(0,0,0,0.1);\r\n  color: #333;\r\n  margin-top: 0;\r\n}\r\n.tr-report-card .ul-title { color: #555; text-shadow: none; }\r\n.tr-report-card .ul-item { background: rgba(255,255,255,0.5); color: #333; }\r\n.tr-report-card .ul-item.is-me { background: rgba(251, 191, 36, 0.3); border-left-color: #b45309; color: #000; }\r\n.tr-report-card .ul-score { color: #15803d; }\r\n\r\n/* --- ВИЗУАЛЬНЫЕ ЭФФЕКТЫ БОНУСОВ --- */\r\n.tetris-fx {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  z-index: 50;\r\n  pointer-events: none;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  animation: fx-float-up 2.5s cubic-bezier(0.25, 1, 0.5, 1) forwards;\r\n  text-shadow: 0 4px 10px rgba(0,0,0,0.8);\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Эффект: Убранные 4 линии (Тетрис) */\r\n.fx-tetris .fx-text {\r\n  color: #f1c40f;\r\n  font-size: 28px;\r\n  font-weight: 900;\r\n  letter-spacing: 2px;\r\n  animation: fx-pulse 0.5s infinite alternate;\r\n}\r\n.fx-tetris .fx-points {\r\n  color: #fff;\r\n  font-size: 36px;\r\n  font-weight: bold;\r\n  text-shadow: 0 2px 5px rgba(0,0,0,1);\r\n}\r\n\r\n/* Эффект: Полная очистка поля */\r\n.fx-perfect_clear .fx-text {\r\n  color: #00ffff;\r\n  font-size: 24px;\r\n  font-weight: 900;\r\n  letter-spacing: 1px;\r\n  animation: fx-rainbow 1.5s infinite linear;\r\n}\r\n.fx-perfect_clear .fx-points {\r\n  color: #fff;\r\n  font-size: 44px;\r\n  font-weight: bold;\r\n  text-shadow: 0 2px 5px rgba(0,0,0,1);\r\n}\r\n\r\n/* Эффект: Убранные 3 линии (Тройной) - Спокойный, без свечения и пульсации */\r\n.fx-triple .fx-text {\r\n  color: #d3dade; /* Благородный серебристо-серый цвет */\r\n  font-size: 24px; /* Чуть меньше, чем у Тетриса (28px) */\r\n  font-weight: 700;\r\n  letter-spacing: 1px;\r\n  text-shadow: 0 2px 4px rgba(0,0,0,0.8); /* Обычная тень для читаемости, без неонового блюра */\r\n}\r\n.fx-triple .fx-points {\r\n  color: #ecf0f1;\r\n  font-size: 28px;\r\n  font-weight: bold;\r\n  text-shadow: 0 2px 4px rgba(0,0,0,0.8);\r\n}\r\n\r\n/* Анимация: Взлет, задержка и угасание текста */\r\n@keyframes fx-float-up {\r\n  0% { transform: translate(-50%, 0%); opacity: 0; scale: 0.5; }\r\n  10% { transform: translate(-50%, -50%); opacity: 1; scale: 1.2; }\r\n  20% { transform: translate(-50%, -50%); opacity: 1; scale: 1; }\r\n  80% { transform: translate(-50%, -80%); opacity: 1; scale: 1; }\r\n  100% { transform: translate(-50%, -100%); opacity: 0; scale: 0.8; }\r\n}\r\n\r\n/* Пульсация света */\r\n@keyframes fx-pulse {\r\n  from { text-shadow: 0 0 10px #f1c40f, 0 0 20px #f1c40f; }\r\n  to { text-shadow: 0 0 20px #e67e22, 0 0 40px #e67e22; }\r\n}\r\n\r\n/* Переливание цветами */\r\n@keyframes fx-rainbow {\r\n  0% { filter: hue-rotate(0deg); text-shadow: 0 0 15px #00ffff; }\r\n  100% { filter: hue-rotate(360deg); text-shadow: 0 0 15px #00ffff; }\r\n}\r\n\r\n/* Эффект: 2 линии (Двойной) */\r\n.fx-double .fx-points {\r\n  color: #aeb6bf;\r\n  font-size: 24px;\r\n  font-weight: bold;\r\n  text-shadow: 0 1px 3px rgba(0,0,0,0.8);\r\n  opacity: 0.8;\r\n}\r\n\r\n/* Эффект: 1 линия (Одинарный) */\r\n.fx-single .fx-points {\r\n  color: #7f8c8d;\r\n  font-size: 18px;\r\n  font-weight: bold;\r\n  text-shadow: 0 1px 2px rgba(0,0,0,0.6);\r\n  opacity: 0.6;\r\n}\r\n\r\n/* --- АНИМАЦИЯ ТРЯСКИ СТАКАНА --- */\r\n.tetris-shake {\r\n  animation: tetris-bump 0.2s ease-out;\r\n}\r\n\r\n/* Высокочастотная микровибрация (очень упругая, уменьшенная амплитуда, больше шагов) */\r\n@keyframes tetris-bump {\r\n  0%   { transform: translateY(0); }\r\n  12%  { transform: translateY(0.8px); }\r\n  25%  { transform: translateY(-0.5px); }\r\n  37%  { transform: translateY(0.6px); }\r\n  50%  { transform: translateY(-0.4px); }\r\n  62%  { transform: translateY(0.4px); }\r\n  75%  { transform: translateY(-0.2px); }\r\n  87%  { transform: translateY(0.2px); }\r\n  100% { transform: translateY(0); }\r\n}\r\n\r\n/* --- СВЕТОВОЙ БЛИК ТОЛЬКО ПО 1-ПИКСЕЛЬНОЙ ОКАНТОВКЕ --- */\r\n.tetris-shake::after {\r\n  content: '';\r\n  position: absolute;\r\n  /* Ложимся строго поверх 1px рамки самого стакана */\r\n  top: 0; left: -1px; right: -1px; bottom: -1px;\r\n\r\n  /* Делаем сам блик той же толщины (1px), без фона внутри */\r\n  border: 1px solid #ffffff;\r\n  border-top: none; /* У стакана нет верхней грани */\r\n\r\n  /* Придаем 1-пиксельной полосе неоновый блеск */\r\n  box-shadow:\r\n      inset 0 0 6px rgba(0, 255, 255, 0.8),\r\n      0 0 6px rgba(0, 255, 255, 0.8),\r\n      inset 0 0 2px #fff,\r\n      0 0 2px #fff;\r\n\r\n  z-index: 100;\r\n  pointer-events: none;\r\n\r\n  /* Создаем маску-прорезь. Всё скрыто, кроме тонкой диагональной полосы */\r\n  -webkit-mask-image: linear-gradient(\r\n      45deg,\r\n      transparent 48%,\r\n      black 49%,\r\n      black 51%,\r\n      transparent 52%\r\n  );\r\n  mask-image: linear-gradient(\r\n      45deg,\r\n      transparent 48%,\r\n      black 49%,\r\n      black 51%,\r\n      transparent 52%\r\n  );\r\n\r\n  /* Делаем маску гигантской (2000px), чтобы прорезь была ровной и длинной */\r\n  -webkit-mask-size: 2000px 2000px;\r\n  mask-size: 2000px 2000px;\r\n  -webkit-mask-repeat: no-repeat;\r\n  mask-repeat: no-repeat;\r\n\r\n  /* Проносим эту прорезь снизу вверх за 0.2с */\r\n  animation: border-spark 0.4s linear forwards;\r\n}\r\n\r\n/* Анимация движения маски от левого нижнего угла к правому верхнему */\r\n@keyframes border-spark {\r\n  0% {\r\n    -webkit-mask-position: -500px 500px;\r\n    mask-position: -500px 500px;\r\n  }\r\n  100% {\r\n    -webkit-mask-position: 500px -1000px;\r\n    mask-position: 500px -1000px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
